export function receiveRemoveStickyNotificationResponse(context, { payload }) {
    const { notificationId } = payload;
    const notifications = context.getMethodsOf('notifications');
    notifications.removeStickyNotification(notificationId);
}
